export default __webpack_public_path__ + "static/media/watch_1.c02eefda.png";